export default "__VITE_ASSET__CvwDMNrf__"